import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { HomeComponent } from './home';
import { PolicyNumberMaintainComponent } from './home/policy-number-maintain/policy-number-maintain.component';
import { AuthGuard } from './_helpers';
import { PrintComponent } from './printNew/print/print.component';
import { PaymentAddComponent } from './employee/payment-add/payment-add.component';
import { EmployeeDealerAssignmentComponent } from './_components/admin/employee-dealer-assignment/employee-dealer-assignment.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RsaProviderReportComponent } from './reports/rsa-provider-report.component';
import { DealerRevenueComponent } from './admin/dealer-revenue/dealer-revenue.component';
import { PrintInstructionManagerComponent } from './config-maintain/print-instruction-manager/print-instruction-manager.component';
import { ModelManagerComponent } from './config-maintain/model-manager/model-manager.component';
import { ProductMasterComponent } from './reports/product-master/product-master.component';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const usersModule = () => import('./users/users.module').then(x => x.UsersModule);
const reportsModule = () => import('./reports/reports.module').then(x => x.ReportsModule);
const issueCertificateModule = () => import('./issue-certificate/IssueCertificateModule').then(x => x.IssueCertificateModule); 
const AnayticModule = () => import('./analytics/anaytic.module').then(x => x.AnayticModule); 
const ConfigMaintainModule = () => import('./config-maintain/config-maintain.module').then(x => x.ConfigMaintainModule);

export const routes: Routes = [
    { path: '', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'users', loadChildren: usersModule, canActivate: [AuthGuard] },
    { path: 'issueCertificate', loadChildren: issueCertificateModule, canActivate: [AuthGuard] },
    { path: 'account', loadChildren: accountModule },
    { path: 'reports', loadChildren: reportsModule },
    { path: 'product-master', component: ProductMasterComponent, canActivate: [AuthGuard] },
    {path: 'printNew',component:PrintComponent},
    {path: 'analytics', loadChildren:AnayticModule},
    {path:'configMaintain',loadChildren: ConfigMaintainModule},
    {path: 'configUpdate/PrintInstruction', component: PrintInstructionManagerComponent, canActivate: [AuthGuard]},
    {path: 'configUpdate/Model', component: ModelManagerComponent, canActivate: [AuthGuard]},
    {path: 'configUpdate/:id', component: PolicyNumberMaintainComponent},
    {path:'empAddPayment',component:PaymentAddComponent},
    {path:'empDealerAssign',component:EmployeeDealerAssignmentComponent},
    { path: 'admin/dealerRevenue', component: DealerRevenueComponent, canActivate: [AuthGuard] },
    // Removed direct reports/rsa-provider route; it should be handled in reports-routing.module
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload',
        preloadingStrategy: PreloadAllModules // Preload all lazy-loaded modules in background after initial load
      })],
    exports: [RouterModule]
})
export class AppRoutingModule { }